import { useState } from 'react'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Pencil } from '@factorialco/f0-react/icons/app'
import { JobLevelRateDetailsDocument } from 'generated/resources/graphql'

import { getCurrencySymbolFromCode } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import EditJobRatesSidepanel from 'modules/project_management/components/tables/JobsAndRatesDataCollection/EditJobRatesSidepanel'

type Props = {
  billRate: number
  canManageRate: boolean
  currency: string
  levelName: string
  maxCostRate: number
  minProfitMargin: number
  roleLevelId: number
  roleName: string
}

export const RoleDetailsHeader = ({
  billRate,
  canManageRate,
  currency,
  levelName,
  maxCostRate,
  minProfitMargin,
  roleLevelId,
  roleName,
}: Props) => {
  const [showEditJobRatesSidepanel, setShowEditJobRatesSidepanel] = useState<boolean>(false)
  const selectedRoleLevelInfo = {
    name: levelName,
    id: roleLevelId,
    maxCostRate: maxCostRate,
    billingRateCents: billRate,
    profitabilityPercentageCents: minProfitMargin,
    currency: currency,
  }

  return (
    <>
      <ResourceHeader
        title={roleName}
        metadata={[
          {
            label: i18n.t('project_management.headers.seniority'),
            value: {
              type: 'text',
              content: levelName,
            },
          },
          {
            label: i18n.t('project_management.headers.max_cost_rate'),
            value: {
              type: 'text',
              content: (maxCostRate / 100).toString() + getCurrencySymbolFromCode(currency),
            },
          },
          {
            label: i18n.t('project_management.headers.bill_rate'),
            value: {
              type: 'text',
              content: (billRate / 100).toString() + getCurrencySymbolFromCode(currency),
            },
          },
          {
            label: i18n.t('project_management.headers.min_profit_margin'),
            value: {
              type: 'text',
              content: minProfitMargin / 100 + '%',
            },
          },
        ]}
        primaryAction={{
          label: i18n.t('project_management.job_level_employees.main_action_button'),
          icon: Pencil,
          isVisible: canManageRate,
          onClick: () => {
            setShowEditJobRatesSidepanel(true)
          },
        }}
      />
      <EditJobRatesSidepanel
        showSidePanel={showEditJobRatesSidepanel}
        onClose={() => setShowEditJobRatesSidepanel(false)}
        refetchQueries={[JobLevelRateDetailsDocument]}
        selectedRoleLevelInfo={selectedRoleLevelInfo}
      />
    </>
  )
}
